module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail5.4e8dcb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail5.jpg
// module id = 6zcB
// module chunks = 6